
import { BaseResponseDto, DeleteMissionRequest, GetMissionFilter, Mission, PostMissionRequest, PutMissionRequest } from "@aoe/client";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const missionActions = createActionGroup({
    source: 'Missions',
    events: {
        ['[Mission - API] Load mission']: props<{ paylod: GetMissionFilter }>(),
        ['[Mission - API] Load success']: props<BaseResponseDto<Mission.MissionListDto>>(),
        ['[Mission - API] Load failed']: props<BaseResponseDto<Mission.MissionListDto>>(),
        ['[Mission - API] Create mission']: props<{ paylod: PostMissionRequest }>(),
        ['[Mission - API] Update mission']: props<{ paylod: PutMissionRequest }>(),
        ['[Mission] Update mission']: props<{ payload: Mission.MissionDto }>(),
        ['[Mission] - API] Delete mission']: props<{ paylod: DeleteMissionRequest }>(),
        [`[Mission - API] Reset mission`]: emptyProps()

    }
})

// export const loadFromApiVolunteer = createAction(`[Volunteer - API] Load volunteer`, props<GetVolunteerFilter>());
// export const loadVolunteerSucces = createAction('[Volunteer - API] Load success', props<BaseResponseDto<Volunteer.VolunteerListDto>>())
// export const loadVolunteerFailed = createAction('[Volunteer - API] Load failed', props<BaseResponseDto<Volunteer.VolunteerListDto>>())
// export const createFromApiVolunteer = createAction(`[Volunteer - API] Create volunteer`, props<PostVolunteerRequest>());
// export const updateFromApiVolunteer = createAction(`[Volunteer - API] Update volunteer`, props<PutVolunteerRequest>());
// export const updateVolunteerItem = createAction(`[Volunteer] Update volunteer`, props<Volunteer.VolunteerDto>());
// export const deleteFromApiVolunteer = createAction(`[Volunteer - API] Delete volunteer`, props<DeleteVolunteerRequest>());
// export const resetVolunteer = createAction(`[Volunteer - API] Reset volunteer`);
